"use client";
import styles from '../../styles/Spinner.module.css';

export default function Spinner({ size = 40, color = '#3b82f6' }) {
  return (
    <div 
      className={styles.spinner} 
      style={{ 
        width: size, 
        height: size,
        borderColor: color,
        borderBottomColor: 'transparent'
      }}
    />
  );
}